import React, { Fragment, useMemo, useState } from "react"
import { PlatformsAndSocials } from "../../../components/ui/profileSetup/links/PlatformsAndSocials";
import { useCategories } from "../../../hooks/apiHooks/useCategories";
import { useFormik } from "formik";
import { createOrUpdateCategoriesValues } from "../../../config/apisauce";
import { VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import useNotiStack from "../../../hooks/useNotiStack";
import { EditProfileButtons } from "./EditProfileButtons";
import { formatCategoryValues, removeNullValues } from "../../../components/generic/functions/genericFunctions";
import { Box } from "@mui/material";

export const EditPlatformsForm = ({ platformValues, creatorDetails, handleClose, refetchDetails }) => {
  const { success, error } = useNotiStack();
  const [loading, setLoading] = useState(false);
  const { data: categoriesList } = useCategories({ type: ['platforms'] });

  const initialPlatforms = useMemo(() => {
    return formatCategoryValues(platformValues);
  }, [platformValues]);

  const handleSubmit = async (data) => {
    setLoading(true);
    if (removeNullValues(data)?.length < 1) {
      error('Add atleast one (1) platform');
    } else {
      const categories = Object.entries(data).map(([key, value]) => ({
        user_id: creatorDetails?.user_id,
        categories_id: Number(key),
        value: value
      }));
      const response = await createOrUpdateCategoriesValues({
        current_step: VERIFY_FACE_ID_KEY,
        categories: categories,
        user_id: creatorDetails?.user_id,
      });
      if (response.ok) {
        success('Successfully updated platforms!');
        handleClose();
        refetchDetails();
      }
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: initialPlatforms,
    enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values)
  })

  return (
    <Fragment>
      <Box sx={{ overflowX: 'auto', maxHeight: '70vh' }}>
        <PlatformsAndSocials
          formik={formik}
          fields={categoriesList}
          subTitle={'one (1) platform'}
        />
      </Box>
      <EditProfileButtons
        handCancel={() => handleClose()}
        handleSubmit={() => formik?.handleSubmit()}
        loading={loading}
      />
    </Fragment>
  )
};